<template>
<td>
     <div class="km-widget km-buttongroup k-widget k-button-group k-button-narrow">

                    <button
                        class="k-primary k-button k-grid-edit-command"
                        @click="uredi" title="Obrat">
                         <font-awesome-icon icon="edit"/>
                    </button>

                    <button
                        class="k-primary k-button k-grid-edit-command"
                        @click="urediDislociraneEnote" title="Dislocirane enote">
                         <font-awesome-icon icon="building"/>
                    </button>
                    <button
                        class="k-primary k-button k-grid-edit-command"
                        @click="UrediDejavnosti" title="Dejavnosti">
                         <font-awesome-icon icon="cogs"/>
                    </button>
                    <button
                        class="k-primary k-button k-grid-edit-command"
                        @click="urediKontrole" title="Kontrole">
                         <font-awesome-icon icon="search-location"/>
                    </button>
                     <button
                        class="k-primary k-button k-grid-edit-command"
                        @click="urediCertifikat" title="Certifikat">
                         <font-awesome-icon icon="certificate"/>
                    </button>
                    </div>
                </td>
</template>
<script>

//import { pridelavaService } from '../../services/pridelava.service';
//import { Button } from '@progress/kendo-vue-buttons';
export default {
    props: {
        field: String,
        dataItem: Object,
        format: String,
        className: String,
        columnIndex: Number,
        columnsCount: Number,
        rowType: String,
        level: Number,
        expanded: Boolean,
        editor: String,
        sezona: Number
    },
    computed: {
        //poglej če je group header
        //poglej če obstaja this.dataItem.field in potem this.data.items[0][field]
    
     
    },
    template: ` 
                `,
    methods: {
        //...mapActions('predelava', ['select']),
       
        uredi: function() {
           //this.select({predelovalec:this.dataItem});
           
           this.$router.push({ name: 'predelovalec', params: { sezona: this.dataItem.sezona, predelovalec:this.dataItem, predelovalecid:this.dataItem.id } })
            
        },
        urediDislociraneEnote: function() {
           //this.select({predelovalec:this.dataItem});
           
           this.$router.push({ name: 'dislociranaEnota', params: { sezona: this.dataItem.sezona, predelovalec:this.dataItem, predelovalecid:this.dataItem.id } })
            
        },
          UrediDejavnosti: function() {
           //this.select({predelovalec:this.dataItem});
           
           this.$router.push({ name: 'dejavnost', params: { sezona: this.dataItem.sezona, predelovalec:this.dataItem, predelovalecid:this.dataItem.id } })
            
        },
        urediKontrole: function() {
           //this.select({predelovalec:this.dataItem});
           
           this.$router.push({ name: 'kontrolaPredelava', params: { sezona: this.dataItem.sezona, predelovalec:this.dataItem, predelovalecid:this.dataItem.id } })
            
        },
         urediCertifikat: function() {
           //this.select({predelovalec:this.dataItem});
           
           this.$router.push({ name: 'certifikatPredelava', params: { sezona: this.dataItem.sezona, predelovalec:this.dataItem, predelovalecid:this.dataItem.id } })
            
        }
    }
}
</script>
